export default "__VITE_ASSET__B$qiLY0y__"